<script>
const SITE_KEY = process.env.VUE_APP_TURNSTILE_SITE_KEY

export default {
  name: 'turnstyle-validate',
  data() {
    return {
      cftoken: '',
      widgetId: '',
    }
  },
  methods: {
    onSuccess(token) {
      this.cftoken = token
      this.$emit('cftsjwt', { token: this.cftoken })
    },
    onError(errorCode) {
      console.error('Cloudflare Turnstile Challenge Error: \n', errorCode)
    },
    onExpired() {
      console.error('Token expired')
    },
    onTimeout() {
      console.error('Challenge timed out')
    },
    async init() {
      this.widgetId = await window.turnstile.render('#turnstile-container', {
        callback: this.onSuccess,
        sitekey: SITE_KEY,
        execution: 'render', //'execute',
        appearance: 'interaction-only',
        expiredCallback: this.onExpired,
        timeoutCallback: this.onTimeout,
        errorCallback: this.onError,
        refreshTimeout: 'auto',
        retryInterval: 'auto',
        size: 'flexible',
        language: 'auto',
        theme: 'dark',
      })
    },
    async execute() {
      this.widgetId = await window.turnstile.execute('#turnstile-container')
    },
  },
  emits: {
    cftsjwt: (token) => {
      return token
    },
  },
  async mounted() {
    const inter = setInterval(() => {
      if (typeof window.turnstile !== 'undefined') {
        this.init()
        clearInterval(inter)
      }
    }, 500)
  },
}
</script>

<template>
  <div id="turnstile-container"></div>
</template>
